import React from 'react';
import './Features.css';

const Features: React.FC = () => {
  const features = [
    {
      icon: '⚡',
      title: 'Real-Time Token Analysis',
      description: 'Get instant, precise token counts for both JSON and TOON formats using industry-standard tokenization. Track your savings in real-time as you convert.',
      benefit: 'Know exactly how much you\'re saving'
    },
    {
      icon: '🔍',
      title: 'Smart Syntax Validation',
      description: 'Advanced JSON validation with helpful error messages and line-by-line highlighting. Ensures your data is perfect before conversion.',
      benefit: 'Catch errors before they cost you'
    },
    {
      icon: '📋',
      title: 'One-Click Operations',
      description: 'Copy, download, or format your data instantly. Streamlined workflow designed for developer productivity and efficiency.',
      benefit: 'Save time with quick actions'
    },
    {
      icon: '📦',
      title: 'Large File Support',
      description: 'Process JSON files up to 10MB with ease. Handles complex nested structures, large arrays, and deeply nested objects without breaking a sweat.',
      benefit: 'No size limitations for your data'
    },
    {
      icon: '🔒',
      title: '100% Privacy Guaranteed',
      description: 'All conversions happen locally in your browser. Zero server uploads, zero data collection, zero tracking. Your data never leaves your machine.',
      benefit: 'Complete confidentiality for sensitive data'
    },
    {
      icon: '💰',
      title: '30-60% Token Savings',
      description: 'Proven token reduction across all major LLM providers. Independent benchmarks show consistent savings with GPT-4, Claude, Gemini, and more.',
      benefit: 'Cut your API costs in half'
    },
    {
      icon: '🔄',
      title: 'Lossless Conversion',
      description: 'Perfect data preservation during conversion. All values, types, null handling, and nested relationships remain exactly as they were.',
      benefit: 'Zero data loss or corruption'
    },
    {
      icon: '⚙️',
      title: 'Developer-Friendly',
      description: 'Simple, intuitive interface designed for developers. Copy, paste, and convert with just a few clicks. Perfect for integrating into your development workflow.',
      benefit: 'Streamline your development process'
    },
    {
      icon: '🎨',
      title: 'Beautiful Dark Mode',
      description: 'Eye-friendly dark mode that automatically matches your system preferences. Smooth theme transitions for comfortable extended use.',
      benefit: 'Code comfortably at any time'
    },
    {
      icon: '🚀',
      title: 'Lightning Fast',
      description: 'Built with performance in mind. Zero external dependencies, optimized algorithms, and instant conversions even for large datasets.',
      benefit: 'No waiting, just results'
    },
    {
      icon: '📱',
      title: 'Fully Responsive',
      description: 'Works perfectly on desktop, tablet, and mobile devices. Convert data anywhere, on any device, with a seamless experience.',
      benefit: 'Work from anywhere'
    },
    {
      icon: '🎯',
      title: 'Universal LLM Support',
      description: 'Compatible with OpenAI, Anthropic, Google, Cohere, and all open-source models. TOON format works everywhere JSON works—but better.',
      benefit: 'Use with any AI provider'
    }
  ];

  return (
    <section className="features-section" id="features" aria-labelledby="features-heading">
      <div className="features-container">
        <header className="features-header">
          <h2 id="features-heading" className="features-title">
            Powerful Features Built for Developers
          </h2>
          <p className="features-subtitle">
            Everything you need to optimize your LLM token usage and reduce API costs
          </p>
        </header>

        <div className="features-grid">
          {features.map((feature, index) => (
            <article key={index} className="feature-card">
              <div className="feature-icon" aria-hidden="true">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <div className="feature-benefit">
                <span className="benefit-icon">✓</span>
                <span>{feature.benefit}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="features-cta">
          <p className="cta-text">Ready to start saving on your LLM costs?</p>
          <a href="#converter" className="cta-button">
            Try the Converter Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features;
